import { Linking } from 'react-native';
import { AVATAR_SIZE, BASE_FONT_SIZE, LINE_HEIGHT } from '../../../Constants';
const renderersProps = (navigation, topicId, showUserProfile, baseUrl) => {
  /**
   * a here stands for <a> tag
   * tag names should be used, such as ol, ul and img.
   * https://meliorence.github.io/react-native-render-html/api/renderersprops
   */
  return {
    a: {
      onPress(event, href, htmlAttribs, target) {
        event.preventDefault(); // prevent default page refresh

        if (htmlAttribs && htmlAttribs.class && htmlAttribs.class === 'mention') {
          let userForModal = {}; // reset userForModal each time
          // anchor tag for mention
          // open profile modal

          userForModal = {
            name: htmlAttribs['data-value'],
            username: htmlAttribs['data-username'],
            avatar_template: baseUrl + htmlAttribs['data-avatar_template'].replace(/\{size\}/, AVATAR_SIZE)
          };
          showUserProfile(userForModal);
        } else {
          // anchor tag for urls
          // open the link
          Linking.openURL(href);
        }
      }
    }
    // just leaving an example
    // img: {}
  };
};
const Post = {
  tagsStyles: {
    p: {
      margin: 0,
      padding: 0,
      fontSize: BASE_FONT_SIZE,
      lineHeight: LINE_HEIGHT
    },
    ul: {
      marginTop: 5,
      marginLeft: 10,
      marginRight: 10,
      paddingLeft: 10,
      paddingRight: 10
    }
  },
  renderersProps
};
export default Post;
//# sourceMappingURL=Post.js.map